import {
  REQUEST_ANSWER_INFO,
  REQUEST_ANSWER_INFO_SUCCESS,
  REQUEST_ANSWER_INFO_ERROR,
  REQUEST_ANSWER_PAGE_SET,
  REQUEST_ANSWER_EDIT_MODAL_SET,
  REQUEST_ANSWER_EDIT_CHANGE,
  REQUEST_ANSWER_UPDATE,
  REQUEST_ANSWER_UPDATE_SUCCESS,
  REQUEST_ANSWER_UPDATE_ERROR
} from '../actions';

const INIT_STATE = {
  loading: true,
  list: {
    data:[],
    page:{
      current: 1,
      rows: 10
    }
  },
  info: {
    data: [],
    loading: true,
  },
  edit: {
    loading: true,
    data: {
      new:[],
      old:[]
    },
    modal: false,
    update: {
      loading: false,
      response: '',
      message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_ANSWER_INFO:
      return {
        ...state,
        info: {
          ...state.info,
          loading: true,
        }
      }
    case REQUEST_ANSWER_INFO_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload ,
            old: action.payload
          }
        }
      }
    case REQUEST_ANSWER_INFO_ERROR:
      return {
        ...state,
        info: {
          ...state.info,
          loading: false
        }
      }
    case REQUEST_ANSWER_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        }
      }
    case REQUEST_ANSWER_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case REQUEST_ANSWER_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case REQUEST_ANSWER_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case REQUEST_ANSWER_UPDATE_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal:false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new
            },
            old: {
              ...state.edit.data.new
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        }
      }
    case REQUEST_ANSWER_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    default:
      return { ...state };
  }
};